module.exports = __webpack_public_path__ + "static/sean.4aeae5cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logos/sean.svg
// module id = 748
// module chunks = 114276838955818